/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { BsFillTrashFill } from "react-icons/bs";
import { ModalContext } from "../../context/modal";
import { Skeleton } from "../../components/Skeleton/table";
import { toast } from "react-toastify";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import MyTooltip from "../../components/Tooltip";
import { BiMessageSquareEdit } from "react-icons/bi";
import Select from "react-select";
import { customStyles } from "../../style/selectStyles";
import { MyHorizontalScrollView } from "../Sectors/style";
import { ModalLandbotEdit } from "./modal-edit";
import { ModalLandbotDelete } from "./modal-delete";
import { ModalLandbotCreate } from "./modal-create";
function LandbotChannels() {
	const { open, handleOpenModal } = useContext(ModalContext);
	const [tableData, setTableData] = useState();
	const [selectAccountFilterData, setSelectAccountFilterData] = useState([{}]);
	const [selectedAccountFilterData, setSelectedAccountFilterData] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [modalData, setModalData] = useState({});
	const [modalLandbotEdit, setModalLandbotEdit] = useState(false);
	const [modalLandbotDelete, setModalLandbotDelete] = useState(false);
	const [modalLandbotCreate, setModalLandbotCreate] = useState(false);

	const handleModalEdit = () => {
		setModalLandbotEdit(true);
		setModalLandbotCreate(false);
		setModalLandbotDelete(false);
		handleOpenModal();
	};
	const handleModalCreate = () => {
		setModalLandbotEdit(false);
		setModalLandbotCreate(true);
		setModalLandbotDelete(false);
		handleOpenModal();
	};
	const handleModalDelete = () => {
		setModalLandbotEdit(false);
		setModalLandbotCreate(false);
		setModalLandbotDelete(true);
		handleOpenModal();
	};

	const populateTable = async (company = "") => {
		try {
			setIsLoading(true);
			const { data } = await authApi.post("/landbotchannel/list", {
				accountId: company,
			});
			setIsLoading(false);
			setTableData(data);
		} catch (error) {
			setIsLoading(false);
			toast.error("Não foi possivel encontrar os setores", TOASTIFY_OPTIONS);
		}
	};

	const populateSelect = async () => {
		try {
			const { data } = await authApi.get("/account/all/select");
			const seriData = [];
			data.forEach((item) => {
				seriData.push({ label: item.name, value: item._id });
			});
			setSelectAccountFilterData(seriData);
		} catch (error) {
			toast.error(
				"Não foi possivel encontrar os dados para filtro",
				TOASTIFY_OPTIONS
			);
		}
	};
	useEffect(() => {
		populateSelect();
		populateTable();
	}, []);

	return (
		<Page>
			{/* Handle modals below */}
			{open && modalLandbotEdit && (
				<ModalLandbotEdit
					open={open}
					data={modalData}
					populateTable={populateTable}
					clients={selectAccountFilterData}
				/>
			)}
			{open && modalLandbotCreate && (
				<ModalLandbotCreate
					open={open}
					populateTable={populateTable}
					clients={selectAccountFilterData}
				/>
			)}
			{open && modalLandbotDelete && (
				<ModalLandbotDelete
					open={open}
					data={modalData}
					populateTable={populateTable}
					clients={selectAccountFilterData}
				/>
			)}
			<Sidebar activeMenu="landbot" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Canais do Landbot</span>
							<DefaultButton
								headerButton
								onClick={() => {
									handleModalCreate();
								}}
							>
								Cadastrar novo canal
							</DefaultButton>
						</Apresentation>
						{isLoading ? (
							<Skeleton data={["Cliente", "Token", "Ação"]} />
						) : (
							<>
								<MyHorizontalScrollView>
									<div>
										<Select
											styles={customStyles}
											placeholder={"Filtrar por cliente"}
											options={[
												{ label: "Todos", value: "" },
												...selectAccountFilterData,
											]}
											onChange={(e) => {
												setSelectedAccountFilterData(e);
												populateTable(e.value);
											}}
											value={selectedAccountFilterData}
											noOptionsMessage={() => "Nenhum dado encontrado!"}
										/>
									</div>
								</MyHorizontalScrollView>

								{tableData && tableData.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>id</th>
													<th>Cliente</th>
													<th>Token</th>
													<th>Ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{tableData?.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item._id ? item._id : "-"}</td>
														<td>{item.accountName ? item.accountName : "-"}</td>
														<td>
															{item.channelToken ? item.channelToken : "-"}
														</td>
														<td
															style={{
																display: "flex",
																justifyContent: "space-around",
															}}
														>
															<MyTooltip label={`Editar: ${item.accountName}`}>
																<DefaultButton
																	onClick={() => {
																		handleModalEdit();
																		setModalData(item);
																	}}
																>
																	<BiMessageSquareEdit size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label={`Excluir: ${item.accountName}`}>
																<DefaultButton
																	onClick={() => {
																		handleModalDelete();
																		setModalData(item);
																	}}
																>
																	<BsFillTrashFill size={20} />
																</DefaultButton>
															</MyTooltip>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export default LandbotChannels;
